<template>
  <box-model title="病虫情勘测">
    <template v-slot:content> 
      <div class="con-is">
        <div v-if="!detail.createTime" class="no-data-sty" style="height: 234px;">暂无数据</div>
        <div v-else>
          <div class="u-time">更新时间 {{ detail.createTime }}</div>
          <div class="detail">
            <img class="d-img" :src="detail.image" />
            <div class="d-content">
              <div v-for="(item, index) in detail.resList" :key="index" class="dc-item flex-y-center">
                <div class="clc" :class="+item.percentage<0.3?'clc-sty':''"></div>
                <div class="txt">{{ item.name || '--' }}</div>
                <div class="left flex-y-center" style="justify-content: space-between;">
                  <div>置信度</div>
                  <div class="flex-y-center">
                    <div class="l-num">{{ Math.floor(((+item.percentage)*100)) || '--' }}</div>
                    <div>%</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="warning flex-y-center">
            <img class="w-img" src="../../assets/img/notice.png" />
            <span class="c1">蓝色预警</span>
            <span class="c1" style="margin: 0 6px;">|</span>
            <span class="c2">虫情预警</span>
            <span class="time">{{ detail.createTime }}</span>
          </div>
        </div>
      </div>
    </template>
  </box-model>
</template>
<script>
  import { getLastData} from "@/api/index";
  export default {
    data() {
      return {
        detail: {}
      }
    },  
    components: {
      "box-model": () => import("../../components/common/Model.vue"),
      "select-box": () => import("../../components/common/SelectBox.vue")
    },
    mounted(){
      this.getLastDataFn();
    },
    methods: {
      getLastDataFn(){
        getLastData().then((res) => {
          this.detail = res.data || {};
        });
      },
    }
  }
</script>
<style scoped lang="less">
  .con-is {
    position: relative;
    width: 100%;
    .u-time {
      font-size: 18px;
      font-weight: 400;
      color: #4ADDFF;
      line-height: 18px;
    }
    .detail {
      position: relative;
      width: 100%;
      margin-top: 10px;
      padding-left: 50%;
      .d-img {
        position: absolute;
        top: 0;
        left: 0;
        width: 50%;
        height: 160px;
        background: #999999;
      }
      .d-content {
        width: 100%;
        height: 160px;
        overflow-y: scroll;
        overflow-x: hidden;
        .dc-item {
          width: 100%;
          padding-left: 18px;
          font-size: 18px;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 18px;
          margin-bottom: 12px;
          
          .clc {
            width: 8px;
            height: 8px;
            background: linear-gradient(180deg, #FF6637 1%, #F4A260 99%);
            border-radius: 50px 50px 50px 50px;
            opacity: 1;
          }
          .clc-sty {
            background: linear-gradient(180deg, #0580B7 0%, #06F7A1 100%);
          }
          .txt {
            width: 166px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-left: 4px;
          }
          .left {
            width: 80px;
            font-size: 16px;
            font-weight: 400;
            color: rgba(255,255,255,0.7);
            line-height: 16px;
            margin-left: auto;
            .l-num {
              font-size: 18px;
              font-weight: 400;
              color: #4ADDFF;
            }
          }
        }
        .dc-item:last-child {
          margin-bottom: 0;
        }
      }
    }
    .warning {
      width: 100%;
      height: 40px;
      background: rgba(9,148,255,0.14);
      margin: 0 auto;
      margin-top: 10px;
      padding: 0 10px;
      font-size: 18px;
      font-weight: 700;
      .w-img {
        width: 24px;
        height: 24px;
        margin-right: 10px;
      }
      .c1 {
        color: #4ADDFF;
      }
      .c2 {
        color: #FFFFFF;
      }
      .time {
        margin-left: auto;
        font-size: 18px;
        font-weight: 400;
        color: #4ADDFF;
      }
    }
  }
</style>